module.exports = __webpack_public_path__ + "static/media/Extra@2x.e842c0d7.png";